import { useTypedMutation } from "hooks";
import { prepareWarrantyQueryPayload } from "modules/WarrantyDashboard/hooks/useWarrantyQuery";
import { ApiInstance } from "utils/Api";

import type { WarrantyDashboardFilters } from "modules/WarrantyDashboard/queryKeys";

export const useExportWarrantyDashboard = () =>
  useTypedMutation({
    mutationFn: async (filters: WarrantyDashboardFilters) => {
      await ApiInstance.post("/pins/export/enqueue", prepareWarrantyQueryPayload(filters));
    },
    onSuccess: () => null
  });
